var _path, _path2, _path3, _rect, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8ProtectiveGlasses50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b3d7",
    d: "M44.759,20.349l-12-14C32.569,6.127,32.292,6,32,6h-3c-2.134,0-3.25,1.509-3.25,3s1.116,3,3.25,3 h0.818l8.428,9.658C38.437,21.875,38.711,22,39,22h5c0.391,0,0.745-0.228,0.909-0.582C45.072,21.063,45.013,20.646,44.759,20.349z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b3d7",
    d: "M19,6h-3c-0.292,0-0.569,0.127-0.759,0.349l-12,14c-0.254,0.296-0.313,0.714-0.149,1.069 C3.255,21.772,3.609,22,4,22h5c0.289,0,0.563-0.125,0.753-0.342L18.182,12H19c1.221,0,1.976-0.499,2.395-0.918 C21.946,10.53,22.25,9.791,22.25,9C22.25,7.509,21.134,6,19,6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7debf5",
    d: "M44,21l-1.669,17.527C42.143,40.494,42.069,42,40,42h-9.292c-1.636,0-3.106-0.951-3.714-2.4 L26,37.227h-4L21.006,39.6c-0.607,1.45-2.078,2.4-3.714,2.4H8c-2.069,0-2.143-1.506-2.331-3.472L4,21H44z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.472,
    height: 2,
    x: 6.764,
    y: 30.5,
    fill: "#c2ffff",
    transform: "rotate(-69.151 17.999 31.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2ffff",
    d: "M30.197,19.932l-6.644,17.439c0.231-0.111,0.484-0.185,0.752-0.206 c0.991-0.078,1.776,0.549,2.323,1.306c0.446,0.618,0.666,1.346,1.042,2.001c0.008,0.014,0.061,0.115,0.098,0.173 c0.003,0.004,0.002,0.002,0.006,0.007c0.062,0.068,0.123,0.136,0.184,0.205c0.156,0.178,0.319,0.366,0.43,0.577 c0.008,0.015,0.012,0.031,0.02,0.046l7.395-19.412L30.197,19.932z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M44.095,20.004c-0.033-0.003-0.062,0.01-0.095,0.01V20H4v0.014c-0.032,0-0.062-0.013-0.095-0.01 c-0.55,0.052-0.953,0.541-0.901,1.09L4.66,38.474C4.905,41.054,7.045,43,9.637,43h9.009c1.234,0,2.327-0.74,2.786-1.886 l0.994-2.485C22.578,38.247,22.943,38,23.354,38h1.292c0.411,0,0.776,0.247,0.928,0.629l0.994,2.485 C27.027,42.26,28.12,43,29.354,43h9.009c2.592,0,4.732-1.946,4.978-4.526l1.655-17.379C45.048,20.545,44.645,20.057,44.095,20.004z M41.349,38.285C41.202,39.833,39.918,41,38.363,41h-9.009c-0.411,0-0.776-0.247-0.928-0.629l-0.994-2.485 C26.973,36.74,25.88,36,24.646,36h-1.292c-1.234,0-2.327,0.74-2.786,1.886l-0.994,2.485C19.422,40.753,19.057,41,18.646,41H9.637 c-1.555,0-2.839-1.167-2.986-2.715L5.1,22h37.8L41.349,38.285z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8ProtectiveGlasses50);
export default __webpack_public_path__ + "static/media/icons8-protective-glasses-50.c3efe821a88b6256d1498878bcbeb3d2.svg";
export { ForwardRef as ReactComponent };